var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnrealengine4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    style: {
      padding: ".5rem"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25 2 C 12.308594 2 2 12.308594 2 25 C 2 37.691406 12.308594 48 25 48 C 37.691406 48 48 37.691406 48 25 C 48 12.308594 37.691406 2 25 2 Z M 25 4 C 36.609375 4 46 13.390625 46 25 C 46 36.609375 36.609375 46 25 46 C 13.390625 46 4 36.609375 4 25 C 4 13.390625 13.390625 4 25 4 Z M 23.621094 10.5 C 15.773438 12.367188 6.65625 21.90625 7.542969 29.125 C 11.8125 21.59375 14.703125 20.570313 15.488281 20.570313 C 16.277344 20.570313 16.703125 20.996094 16.703125 21.90625 L 16.703125 33.128906 C 16.703125 34.523438 15.355469 34.355469 14.460938 34.21875 C 17.773438 39.160156 25.5 39.5 25.5 39.5 L 28.960938 35.738281 L 32.296875 38.589844 C 37.378906 35.300781 40.734375 29.726563 40.734375 28.882813 C 38.21875 31.65625 36.058594 32.160156 35.574219 32.160156 C 35.089844 32.160156 34.300781 32.101563 34.300781 31.433594 L 34.300781 18.121094 C 34.300781 16.964844 37.480469 13.171875 38.484375 11.894531 C 31.871094 13.628906 29.324219 16.933594 29.324219 16.933594 C 29.324219 16.933594 28.433594 16.265625 26.472656 16.265625 C 27.207031 16.890625 28.234375 18.023438 28.234375 19.359375 L 28.234375 31.550781 C 28.234375 31.550781 26.046875 33.128906 24.773438 33.128906 C 23.5 33.128906 22.589844 32.585938 22.589844 31.613281 L 22.589844 17.050781 C 22.589844 17.050781 20.769531 18.328125 20.769531 14.5625 C 20.769531 12.683594 23.621094 10.5 23.621094 10.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnrealengine4Icon);
export default __webpack_public_path__ + "static/media/unrealengine4-icon.d364c6a347411207913e335cb590a3c9.svg";
export { ForwardRef as ReactComponent };